import type { AppNameValue } from '@my/directory-api';

/**
 * A colour per app, used everywhere an app is named in My Hub — the account
 * list's pills, the subscriptions grid, the launcher buttons.
 *
 * <p>
 * ONE MAP, because the value of a colour is recognition: "Depot is the amber
 * one" only works if it is amber in all three places. Defining it per screen is
 * how you end up with Depot amber in a list and green on a button.
 * </p>
 *
 * <p>
 * Rose is deliberately unused — it belongs to the support strip, where it means
 * "you are acting as Stratum support". An app wearing it would blunt that.
 * Slate is likewise left for neutral chrome.
 * </p>
 */
const APP_COLOURS: Record<string, string> = {
  tms: 'border-blue-200 bg-blue-50 text-blue-700',
  depot: 'border-amber-200 bg-amber-50 text-amber-700',
  safety: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  check: 'border-violet-200 bg-violet-50 text-violet-700',
  subsistence: 'border-cyan-200 bg-cyan-50 text-cyan-700',
  hub: 'border-slate-200 bg-slate-50 text-slate-700',
};

/** Fallback keeps an unrecognised app readable rather than unstyled. */
const UNKNOWN = 'border-slate-200 bg-slate-50 text-slate-700';

export function appColour(app: AppNameValue | string): string {
  return APP_COLOURS[String(app).toLowerCase()] ?? UNKNOWN;
}

/** Pill for naming an app inside a table cell or a list. */
export function appPillClass(app: AppNameValue | string): string {
  return `inline-block rounded-full border px-2 py-0.5 text-[10px] font-medium ${appColour(app)}`;
}
